export const BusinessType = {
  EndCustomer: 'endCustomer',
  ValueAddedReseller: 'valueAddedReseller',
};

export const BusinessTypes = [
  { label: 'End Customer', value: BusinessType.EndCustomer },
  { label: 'Value Added Reseller/MSP', value: BusinessType.ValueAddedReseller },
];
